"use client";
import { useState } from "react";
import { usePathname } from "next/navigation";
import NavBar from "./NavBar";
import AppSidebar from "./AppSidebar";
import FeedbackPopup from "./FeedbackPopup";

// Pages that get the plain top-navbar (not the sidebar shell)
const PUBLIC_PATHS = ["/", "/activity"];
// Pages with their own full-page layout (no shell at all)
const STANDALONE_PATHS = ["/onboarding", "/admin"];

function FooterFeedbackLink() {
  const [open, setOpen] = useState(false);
  return (
    <>
      <button
        onClick={() => setOpen(true)}
        className="fixed bottom-4 right-8 z-40 text-[11px] font-semibold text-[#1A1814] bg-[#D5E83F] px-3.5 py-1 rounded-full shadow-md hover:opacity-90 active:scale-95 transition-all"
      >
        Feedback
      </button>
      {open && <FeedbackPopup onClose={() => setOpen(false)} />}
    </>
  );
}

export default function ClientShell({ children }: { children: React.ReactNode }) {
  const pathname = usePathname();
  const isPublic = PUBLIC_PATHS.some(p => pathname === p || pathname.startsWith(p + "/"));
  const isStandalone = STANDALONE_PATHS.some(p => pathname === p || pathname.startsWith(p + "/"));

  if (isStandalone) {
    return <>{children}</>;
  }

  if (isPublic) {
    return (
      <>
        <NavBar />
        <main className="min-h-screen">{children}</main>
        <FooterFeedbackLink />
      </>
    );
  }

  return (
    <div
      className="flex h-screen overflow-hidden"
      style={{ fontFamily: "var(--font-body, Inter, sans-serif)", background: "#F2F0EC" }}
    >
      <AppSidebar />
      <div className="flex-1 min-h-0 flex flex-col overflow-hidden">
        <main className="flex-1 min-h-0 overflow-y-auto">
          {children}
        </main>
        <FooterFeedbackLink />
      </div>
    </div>
  );
}
